/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileKeynote16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.294 1.587l.697 4.338a.697.697 0 01-.688.807H3.697a.697.697 0 01-.688-.807l.697-4.338A.697.697 0 014.394 1h8.212c.342 0 .634.249.688.587zM7.453 4.422c.294.187.656.296 1.047.296.391 0 .753-.11 1.047-.296.301-.19.53-.46.648-.774a1.364 1.364 0 000-.958 1.584 1.584 0 00-.648-.774A1.958 1.958 0 008.5 1.62c-.391 0-.753.11-1.047.296-.301.19-.53.46-.648.774a1.365 1.365 0 000 .958c.117.314.347.584.648.774zm-2.764.916c-.248 0-.372.124-.372.31s.124.31.372.31h7.622c.248 0 .372-.124.372-.31s-.124-.31-.372-.31H4.69z"
            fill={vars.bdlGray50}
        />
        <path
            d="M8.887 13.225h2.092c.31 0 .465.155.465.388 0 .232-.155.387-.465.387H6.02c-.31 0-.465-.155-.465-.387 0-.233.155-.388.465-.388h2.092V7.2h.774v6.025z"
            fill={vars.bdlGray50}
        />
    </AccessibleSVG>
);

export default FileKeynote16;
